import { render, staticRenderFns } from "./CityIntro.vue?vue&type=template&id=87a47d86&"
import script from "./CityIntro.vue?vue&type=script&lang=js&"
export * from "./CityIntro.vue?vue&type=script&lang=js&"
import style0 from "./CityIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports